<template>
  <div class="casa">
    <header class="top">
      <a class="wordmark" href="#inicio">
        <img src="/pila/logo.png" alt="Pila">
      </a>
      <nav>
        <a href="#incluso">O que entra</a>
        <a href="#casa">Para a casa</a>
        <a href="#plano">Plano</a>
        <a href="#perguntas">Perguntas</a>
        <a class="back" href="/">Fontes</a>
        <a class="enter" :href="loginUrl">Entrar</a>
        <a class="buy" :href="signupUrl">Criar conta</a>
      </nav>
    </header>

    <main id="inicio">
      <section class="hero">
        <div class="hero-copy">
          <p class="kicker">Pila · pila.fontes.business</p>
          <h1>O mês inteiro da família, sem planilha e sem susto.</h1>
          <p class="lede">
            Despesas, receitas, quem pagou e o que ainda cabe na renda.
            Um plano de R$ 79,90. Android, iPhone e o navegador.
          </p>
          <div class="actions">
            <a class="buy big" :href="signupUrl">Criar conta grátis</a>
            <a class="quiet" :href="loginUrl">Entrar</a>
            <a class="quiet" href="#plano">Ver o plano</a>
          </div>
        </div>
        <aside class="hero-side">
          <div class="mark" aria-hidden="true">
            <img src="/pila/splash.png" alt="">
          </div>
        <aside class="ledger" aria-label="Exemplo do mês">
          <div class="ledger-head">
            <span>Outubro</span>
            <strong>R$ 13.804</strong>
            <em>ainda na conta da casa</em>
          </div>
          <ul>
            <li><span>Aluguel</span><b>R$ 4.060</b></li>
            <li><span>Escola</span><b>R$ 1.575</b></li>
            <li><span>Mercado</span><b>R$ 890</b></li>
            <li class="done"><span>Pago por Anderson</span><b>em dia</b></li>
          </ul>
          <p>A casa fica verde, amarela ou vermelha conforme a renda do mês.</p>
        </aside>
        </aside>
      </section>

      <section class="facts" aria-label="Números do plano">
        <article><strong>5</strong><span>pessoas na mesma conta</span></article>
        <article><strong>79,90</strong><span>reais por mês, plano único</span></article>
        <article><strong>12</strong><span>meses de contas à vista</span></article>
        <article><strong>1</strong><span>chave de inteligência da casa</span></article>
      </section>

      <section class="offer" id="incluso">
        <div class="offer-intro">
          <p class="kicker dark">No primeiro dia</p>
          <h2>A casa já chega organizada.</h2>
        </div>
        <div class="offer-list">
          <article v-for="item in features" :key="item.title">
            <h3>{{ item.title }}</h3>
            <p>{{ item.text }}</p>
          </article>
        </div>
      </section>

      <section class="path">
        <h2>Três passos e o mês aparece.</h2>
        <ol>
          <li>
            <span>01</span>
            <div>
              <h3>Abra a conta</h3>
              <p>Você é o assinante. O plano Família já traz as categorias de gastos e de receitas.</p>
            </div>
          </li>
          <li>
            <span>02</span>
            <div>
              <h3>Chame quem mora junto</h3>
              <p>Cada pessoa entra com o próprio acesso e dá para ver quem pagou a conta.</p>
            </div>
          </li>
          <li>
            <span>03</span>
            <div>
              <h3>Deixe o aviso chegar</h3>
              <p>O WhatsApp lembra a família. A inteligência lê o mês com a chave que você escolher.</p>
            </div>
          </li>
        </ol>
      </section>

      <section class="plan" id="plano">
        <div>
          <p class="kicker">Plano Família</p>
          <h2>R$ 79,90 <small>por mês</small></h2>
          <p>A conta abre na hora. O pagamento libera a casa. Cancele quando quiser.</p>
          <a class="buy big" :href="signupUrl">Começar agora</a>
          <a class="quiet light" :href="loginUrl">Entrar</a>
        </div>
        <ul>
          <li>Até 5 pessoas</li>
          <li>Despesas, receitas e 12 meses</li>
          <li>Objetivos, limites e categorias prontas</li>
          <li>Lembretes e comandos no WhatsApp</li>
          <li>Inteligência com a chave da casa</li>
          <li>Android, iPhone e navegador</li>
        </ul>
      </section>

      <section class="stories" id="casa">
        <div class="offer-intro">
          <p class="kicker dark">Para quem divide a conta</p>
          <h2>A casa inteira enxerga o mesmo mês.</h2>
        </div>
        <div class="offer-list">
          <article v-for="item in stories" :key="item.title">
            <h3>{{ item.title }}</h3>
            <p>{{ item.text }}</p>
          </article>
        </div>
      </section>

      <section class="compare">
        <h2>Planilha aguenta o mês. A casa, não.</h2>
        <div>
          <article>
            <h3>Na planilha</h3>
            <ul>
              <li>Cada um tem um arquivo</li>
              <li>Ninguém sabe quem pagou</li>
              <li>O vencimento passa batido</li>
              <li>O ano que vem é uma aba nova</li>
            </ul>
          </article>
          <article class="yes">
            <h3>No Pila</h3>
            <ul>
              <li>Uma conta, até cinco pessoas</li>
              <li>Quem pagou fica no lançamento</li>
              <li>WhatsApp avisa a família</li>
              <li>Doze meses já aparecem na frente</li>
            </ul>
          </article>
        </div>
      </section>

      <section class="faq" id="perguntas">
        <h2>Antes de criar a conta.</h2>
        <details v-for="item in questions" :key="item.q">
          <summary>{{ item.q }}</summary>
          <p>{{ item.a }}</p>
        </details>
      </section>

      <section class="close">
        <img src="/pila/splash.png" alt="">
        <div>
          <p class="kicker">pila.fontes.business</p>
          <h2>Abra a casa hoje. O cartão é no site.</h2>
          <p>O aplicativo mostra a conta. A assinatura se conclui no navegador, com o plano Família de R$ 79,90.</p>
          <a class="buy big" :href="signupUrl">Criar conta</a>
          <a class="quiet light" :href="loginUrl">Entrar</a>
        </div>
      </section>

      <section class="apps">
        <h2>No bolso e na mesa.</h2>
        <div>
          <article><strong>Android</strong><span>Aplicativo da casa</span></article>
          <article><strong>iPhone</strong><span>Aplicativo da casa</span></article>
          <article><strong>Web</strong><span>pila.fontes.business</span></article>
        </div>
      </section>
    </main>

    <footer>
      <div>
        <p>Pila</p>
        <p class="cnpj">Fontes Business · CNPJ 30.580.155/0001-05</p>
      </div>
      <nav>
        <a :href="loginUrl">Entrar</a>
        <a :href="signupUrl">Criar conta</a>
        <button type="button" @click="openLegal('privacy')">Política de privacidade</button>
        <button type="button" @click="openLegal('terms')">Termos de uso</button>
        <a href="/">Voltar para Fontes Business</a>
      </nav>
    </footer>
    <div v-if="legal" class="sheet" @click.self="legal = null">
      <div class="sheet-card" role="dialog" aria-modal="true" :aria-label="legal.title">
        <button type="button" class="sheet-close" @click="legal = null">Fechar</button>
        <h2>{{ legal.title }}</h2>
        <section v-for="section in legal.sections" :key="section.heading">
          <h3>{{ section.heading }}</h3>
          <p v-for="(paragraph, index) in section.paragraphs" :key="index">{{ paragraph }}</p>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { privacy, terms } from '@/data/pilaDocuments'
import { applyPilaHead } from '@/utils/pilaHead'

export default {
  name: 'FamiliaLanding',
  data() {
    return {
      legal: null,
      loginUrl: 'https://pila.fontes.business/login',
      signupUrl: 'https://pila.fontes.business/login?cadastro=1',
      features: [
        { title: 'Despesas e receitas', text: 'Lança a conta, marca quem pagou e vê o que ainda vence.' },
        { title: 'Doze meses à frente', text: 'O que já está marcado e o que a casa costuma gastar daqui para frente.' },
        { title: 'Objetivos e limites', text: 'O que a casa quer conquistar e o quanto a renda pode comprometer.' },
        { title: 'Categorias prontas', text: 'Moradia, mercado, saúde, salário e o resto. Você edita ou apaga.' },
        { title: 'WhatsApp da casa', text: 'Lembrete da família e de cada pessoa. Peça um resumo no próprio chat.' },
        { title: 'Inteligência da casa', text: 'Uma chave por vez: OpenAI, Gemini ou Claude. O modelo é você quem escolhe.' },
      ],
      stories: [
        { title: 'O casal', text: 'Um lança o mercado, o outro marca o aluguel. Os dois veem o que ainda cabe na renda.' },
        { title: 'Quem paga', text: 'A conta fica no nome da casa e registra a pessoa que pagou. Sem planilha paralela.' },
        { title: 'O mês seguinte', text: 'Conta fixa e parcela já nascem no calendário. O aviso chega no WhatsApp de cada um.' },
        { title: 'A chave de IA', text: 'A casa escolhe o provedor e o modelo. Sem chave, a leitura do período avisa que falta configurar.' },
      ],
      questions: [
        { q: 'Quantas pessoas entram?', a: 'Até cinco pessoas ativas no plano Família. O assinante convida. Cada um entra com o próprio e-mail.' },
        { q: 'O aplicativo cobra o cartão?', a: 'Não. Conta pendente pede para concluir a assinatura em pila.fontes.business. O cartão fica na própria tela do site.' },
        { q: 'Dá para conectar o banco?', a: 'Não. Você lança a despesa e a receita. O Pila organiza o mês, o vencimento e quem pagou.' },
        { q: 'A outra casa vê minhas contas?', a: 'Não. Categoria, despesa e receita ficam na assinatura. Uma casa não enxerga a lista da outra.' },
        { q: 'Posso cancelar?', a: 'Sim. O plano é mensal, R$ 79,90, e a conta abre na hora. O pagamento libera a casa.' },
      ],
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    applyPilaHead()
  },
  methods: {
    openLegal(kind) {
      this.legal = kind === 'terms' ? terms : privacy
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,560;9..144,680&family=Outfit:wght@400;500;600;700&display=swap');

.casa {
  min-height: 100vh;
  background: #f4efe4;
  color: #1c2416;
  font-family: Outfit, sans-serif;
  letter-spacing: 0;
}

.casa * { box-sizing: border-box; }

.casa a { text-decoration: none; }

.top {
  position: sticky;
  top: 0;
  z-index: 5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 18px 6vw;
  background: rgba(244, 239, 228, 0.92);
  backdrop-filter: blur(10px);
}

.wordmark img {
  display: block;
  height: 58px;
  width: auto;
  max-width: min(340px, 46vw);
  object-fit: contain;
}

.top nav {
  display: flex;
  align-items: center;
  gap: 18px;
}

.top nav a { color: #1c2416; font-weight: 600; }

.back {
  border-bottom: 1px solid #1c2416;
  padding-bottom: 2px;
}

.buy {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 42px;
  padding: 0 16px;
  border-radius: 999px;
  background: #e25b2a;
  color: #fff8f3 !important;
  font-weight: 700;
}

.buy.big { min-height: 56px; padding: 0 22px; font-size: 17px; }

.enter {
  display: inline-flex;
  align-items: center;
  min-height: 42px;
  padding: 0 14px;
  border-radius: 999px;
  border: 1px solid #1c2416;
  font-weight: 700;
}

.hero, .offer, .path, .plan, .apps, .facts, .stories, .compare, .faq, .close, footer {
  width: min(1120px, calc(100% - 10vw));
  margin: 0 auto;
}

.hero {
  display: grid;
  grid-template-columns: 1.15fr 0.85fr;
  gap: 48px;
  align-items: end;
  padding: 54px 0 28px;
}

.kicker {
  margin: 0 0 12px;
  color: #e25b2a;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.kicker.dark { color: #0f6e56; }

.casa h1, .casa h2, .casa h3 {
  margin: 0;
  font-family: Fraunces, serif;
  font-weight: 680;
  letter-spacing: -0.03em;
  line-height: 1.02;
}

.casa h1 { font-size: clamp(46px, 6vw, 78px); max-width: 12ch; }
.casa h2 { font-size: clamp(34px, 4vw, 52px); }

.lede, .casa p { font-size: 18px; line-height: 1.55; }

.lede { max-width: 38ch; margin: 18px 0 28px; color: #3d4634; }

.actions { display: flex; gap: 18px; align-items: center; }

.quiet { color: #1c2416; font-weight: 700; border-bottom: 1px solid #1c2416; }
.quiet.light { color: #f7f3ec; border-bottom-color: #f7f3ec; }

.hero-side { display: grid; gap: 14px; align-content: end; }

.mark {
  display: grid;
  place-items: center;
  min-height: 220px;
  border-radius: 28px;
  background: #07080c;
}

.mark img { width: min(200px, 72%); height: auto; }

.ledger {
  background: #fffdf8;
  border-radius: 28px;
  padding: 22px;
  box-shadow: 0 24px 50px rgba(28, 36, 22, 0.08);
}

.ledger-head strong {
  display: block;
  margin-top: 8px;
  font-family: Fraunces, serif;
  font-size: 48px;
  line-height: 1;
}

.ledger-head em { color: #66705c; font-style: normal; }

.ledger ul { list-style: none; margin: 18px 0; padding: 0; }
.ledger li {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-top: 1px solid #efe6d6;
}
.ledger li.done b { color: #0f6e56; }
.ledger p { margin: 0; color: #66705c; font-size: 15px; }

.facts {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  padding: 18px 0 8px;
}

.facts article {
  padding: 18px;
  border-top: 2px solid #1c2416;
}

.facts strong {
  display: block;
  font-family: Fraunces, serif;
  font-size: 36px;
}

.facts span { color: #3d4634; }

.offer { padding: 72px 0 20px; }

.offer-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 48px;
  margin-top: 28px;
}

.offer-list article { padding: 22px 0; border-top: 1px solid #d9d0bf; }
.offer-list p { margin: 8px 0 0; color: #3d4634; }

.path { padding: 48px 0; }
.path ol { list-style: none; margin: 28px 0 0; padding: 0; display: grid; gap: 18px; }
.path li { display: grid; grid-template-columns: 72px 1fr; gap: 12px; align-items: start; }
.path span { font-family: Fraunces, serif; font-size: 28px; color: #e25b2a; }
.path p { margin: 6px 0 0; color: #3d4634; }

.plan {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  margin-bottom: 28px;
  padding: 36px;
  border-radius: 32px;
  background: #173126;
  color: #f4efe4;
}

.plan .kicker, .plan p, .plan li { color: #d7e4d4; }
.plan h2, .plan h2 small { color: #f7f3ec; }
.plan h2 small { font-size: 0.4em; font-weight: 500; }
.plan ul { margin: 0; padding-left: 18px; }
.plan li { margin: 10px 0; font-size: 18px; }

.stories { padding: 36px 0 8px; }

.compare { padding: 28px 0 12px; }
.compare > div { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-top: 22px; }
.compare article { background: #fffdf8; border-radius: 24px; padding: 22px; }
.compare .yes, .compare .yes h3, .compare .yes li { background: #173126; color: #f4efe4; }
.compare .yes h3, .compare .yes li { background: transparent; }
.compare ul { margin: 12px 0 0; padding-left: 18px; }
.compare li { margin: 8px 0; }

.faq { padding: 20px 0 8px; }
.faq details { border-top: 1px solid #d9d0bf; padding: 16px 0; }
.faq summary { cursor: pointer; font-size: 18px; font-weight: 700; }
.faq p { margin: 10px 0 0; color: #3d4634; }

.close {
  display: grid;
  grid-template-columns: 160px 1fr;
  gap: 28px;
  align-items: center;
  margin-top: 28px;
  padding: 28px;
  border-radius: 32px;
  background: #07080c;
  color: #f4efe4;
}
.close img { width: 132px; height: auto; justify-self: center; }
.close .kicker, .close p { color: #d7e4d4; }
.close h2 { color: #f7f3ec; }

.apps { padding: 36px 0 64px; }
.apps div { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-top: 18px; }
.apps article { background: #fffdf8; border-radius: 20px; padding: 20px; }
.apps span { display: block; margin-top: 6px; color: #66705c; }

footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding-bottom: 36px;
}

footer p { margin: 0; font-family: Fraunces, serif; }
footer .cnpj { margin-top: 6px; font-family: Outfit, sans-serif; font-size: 14px; color: #66705c; }
footer nav { display: flex; flex-wrap: wrap; gap: 16px; }
footer a, footer button { color: #1c2416; font-weight: 700; border: 0; border-bottom: 1px solid #1c2416; background: none; padding: 0; cursor: pointer; font: inherit; }
.sheet { position: fixed; inset: 0; z-index: 30; display: grid; place-items: center; padding: 24px; background: rgba(28, 36, 22, 0.46); }
.sheet-card { width: min(720px, 100%); max-height: min(78vh, 720px); overflow: auto; padding: 28px; border-radius: 24px; background: #fffdf8; }
.sheet-card h3 { margin-top: 18px; font-size: 22px; }
.sheet-close { margin-bottom: 8px; border: 0; background: none; color: #0f6e56; font-weight: 700; cursor: pointer; }

@media (max-width: 860px) {
  .top { align-items: flex-start; flex-direction: column; }
  .top nav { flex-wrap: wrap; }
  .hero, .facts, .offer-list, .plan, .apps div, .compare > div, .close { grid-template-columns: 1fr; }
  .wordmark img { height: 46px; }
  .casa h1 { max-width: none; }
  .hero { padding-top: 28px; }
}
</style>
